import { sha256 } from '@noble/hashes/sha256';
import { bytesToHex } from '@noble/hashes/utils';

/** 计算内容寻址 CID：b + sha256(hex)。确定性，用于内容去重与存证。 */
export function computeCid(bytes: Uint8Array): string {
  return 'b' + bytesToHex(sha256(bytes));
}

/** 校验字符串是否合法 CID（b + 64 位 hex）。 */
export function isCid(value: string): boolean {
  return /^b[0-9a-f]{64}$/.test(value);
}
